const fetchData = (pageId, link, title, feedback, token) => `
    {
        monday {
          sendFeedBack(id: ${pageId}, link: "${link}", title: "${title}", feedback: "${feedback}", token: "${token}")
        }
    }
`;

export default fetchData;
